export const categories = [
  {
    id: "film",
    name: "影视剧",
    icon: "ri-film-line",
    description: "热门电影与剧集，感受光影魅力，从科幻大片到都市剧情一网打尽。",
    subCategories: ["全部", "电影", "电视剧", "欧美剧", "日韩剧", "港台剧"],
  },
  {
    id: "entertainment",
    name: "娱乐",
    icon: "ri-star-smile-line",
    description: "明星动态与音乐现场，前沿娱乐资讯与舞台表演精彩不停。",
    subCategories: ["全部", "明星", "音乐", "现场", "时尚"],
  },
  {
    id: "shortvideo",
    name: "短视频",
    icon: "ri-video-line",
    description: "精炼短内容，随时随地轻松观看，几分钟收获快乐与知识。",
    subCategories: ["全部", "搞笑", "生活", "美食", "才艺", "旅行"],
  },
  {
    id: "variety",
    name: "综艺",
    icon: "ri-mic-line",
    description: "热门综艺节目欢乐无限，真人秀、脱口秀与选秀齐聚一堂。",
    subCategories: ["全部", "真人秀", "脱口秀", "选秀", "访谈"],
  },
  {
    id: "anime",
    name: "动漫",
    icon: "ri-emotion-happy-line",
    description: "国漫日漫齐聚，畅享二次元世界，热血与治愈并存。",
    subCategories: ["全部", "国漫", "日漫", "剧场版", "泡面番"],
  },
  {
    id: "documentary",
    name: "纪录片",
    icon: "ri-earth-line",
    description: "记录真实世界，拓展认知边界，探索自然、历史与科技的无限可能。",
    subCategories: ["全部", "自然", "历史", "人文", "科技"],
  },
];

export const regions = ["全部", "中国大陆", "美国", "英国", "日本", "韩国", "中国香港", "法国"];

export const genres = ["全部", "科幻", "动作", "悬疑", "剧情", "喜剧", "爱情", "动画", "纪实", "音乐", "生活"];

export const years = ["全部", "2026", "2025", "2024", "2023 及更早"];

export const durationOptions = ["全部", "短片（10分钟内）", "中长（10-60分钟）", "长片（60分钟以上）"];

export const durationRanges: Record<string, [number, number]> = {
  "短片（10分钟内）": [0, 10],
  "中长（10-60分钟）": [10, 60],
  "长片（60分钟以上）": [60, 100000],
};